// import React from "react";
// import ReadOnlyRow from "./ReadOnlyRow";
// import EditableRow from "./EditableRow";

// const UsersFilteredView = ({
//   users,
//   editContactId,
//   editFormData,

//   handleEditClick,
//   handleDeleteClick,

//   handleEditFormChange,
//   handleEditFormSubmit,
//   handleCancelClick,

//   isLoadingSave,
//   deletingId, // id of the row currently being deleted, or null

//   selectedRecords = [],
//   handleSelectRecord,

//   selectAll,
//   handleSelectAll,

//   sortColumn,
//   sortDirection,
//   handleSort,

//   optionsPreviledges,
//   foundErrAdd,
// }) => {
//   const renderSortIcon = (column) => {
//     if (sortColumn !== column) return " ↕";
//     return sortDirection === "asc" ? " ▲" : " ▼";
//   };

//   return (
//     <div className="overflow-auto w-100 mt3 bg-white br3 shadow-2">
//       <table
//         className="users-table collapse bg-white"
//         style={{ minWidth: "1500px" }}
//       >
//         <thead className="sticky-header">
//           <tr
//             className="bg-gold black"
//             style={{ position: "sticky", top: 0, zIndex: 10 }}
//           >
//             {/* Select */}
//             <th className="pa2 tc nowrap bb b--black-10 f4 fw5">
//               <input
//                 type="checkbox"
//                 checked={selectAll}
//                 onChange={(e) =>
//                   handleSelectAll && handleSelectAll(e.target.checked)
//                 }
//               />
//             </th>

//             <th
//               className="pa2 tl nowrap pointer bb b--black-10 f4 fw5"
//               onClick={() => handleSort?.("id")}
//             >
//               ID{renderSortIcon("id")}
//             </th>

//             <th
//               className="pa2 tl nowrap pointer bb b--black-10 f4 fw5"
//               onClick={() => handleSort?.("farmerid")}
//             >
//               Farmer ID{renderSortIcon("farmerid")}
//             </th>

//             <th
//               className="pa2 tl nowrap pointer bb b--black-10 f4 fw5"
//               onClick={() => handleSort?.("username")}
//             >
//               Username{renderSortIcon("username")}
//             </th>

//             <th
//               className="pa2 tl nowrap pointer bb b--black-10 f4 fw5"
//               onClick={() => handleSort?.("email")}
//             >
//               Email{renderSortIcon("email")}
//             </th>

//             <th className="pa2 tl nowrap bb b--black-10 f4 fw5">Password</th>

//             <th
//               className="pa2 tl nowrap pointer bb b--black-10 f4 fw5"
//               onClick={() => handleSort?.("phone")}
//             >
//               Phone{renderSortIcon("phone")}
//             </th>

//             <th
//               className="pa2 tc nowrap pointer bb b--black-10 f4 fw5"
//               onClick={() => handleSort?.("joined")}
//             >
//               Joined{renderSortIcon("joined")}
//             </th>

//             <th
//               className="pa2 tl nowrap pointer bb b--black-10 f4 fw5"
//               onClick={() => handleSort?.("company")}
//             >
//               Company{renderSortIcon("company")}
//             </th>

//             <th
//               className="pa2 tc nowrap pointer bb b--black-10 f4 fw5"
//               onClick={() => handleSort?.("lastactive")}
//             >
//               Last Active{renderSortIcon("lastactive")}
//             </th>

//             <th
//               className="pa2 tl nowrap pointer bb b--black-10 f4 fw5"
//               onClick={() => handleSort?.("category")}
//             >
//               Privileges{renderSortIcon("category")}
//             </th>

//             <th
//               className="pa2 tc nowrap pointer bb b--black-10 f4 fw5"
//               onClick={() => handleSort?.("status")}
//             >
//               Status{renderSortIcon("status")}
//             </th>

//             <th className="pa2 tc nowrap bb b--black-10 f4 fw5">Actions</th>
//           </tr>
//         </thead>

//         <tbody>
//           {users?.length > 0 ? (
//             users.map((contact) => (
//               <React.Fragment key={contact.id}>
//                 {editContactId === contact.id ? (
//                   <EditableRow
//                     editFormData={editFormData}
//                     handleEditFormSubmit={handleEditFormSubmit}
//                     isLoadingSave={isLoadingSave}
//                     handleEditFormChange={handleEditFormChange}
//                     handleCancelClick={handleCancelClick}
//                     optionsPreviledges={optionsPreviledges}
//                     contact={contact}
//                     foundErrAdd={foundErrAdd}
//                   />
//                 ) : (
//                   <ReadOnlyRow
//                     contact={contact}
//                     handleEditClick={handleEditClick}
//                     handleDeleteClick={handleDeleteClick}
//                     selectedRecords={selectedRecords}
//                     handleSelectRecord={handleSelectRecord}
//                     deletingId={deletingId}
//                   />
//                 )}
//               </React.Fragment>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="13" className="tc pa5 silver f4">
//                 No users found
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default UsersFilteredView;


// UsersFilteredView.js
// Same table shell as RecordsFilteredView.js: sticky gold header, sortable
// columns, a select-all checkbox, and a row-for-row swap between
// ReadOnlyRow and EditableRow depending on which id is being edited.

import React from "react";
import ReadOnlyRow from "./ReadOnlyRow";
import EditableRow from "./EditableRow";
import "./style.css";

const UsersFilteredView = ({
  users,
  editContactId,
  editFormData,

  handleEditClick,
  handleDeleteClick,

  handleEditFormChange,
  handleEditFormSubmit,
  handleCancelClick,

  isLoadingSave,
  deletingId,

  selectedUsers = [],
  handleSelectUser,

  selectAll,
  handleSelectAll,

  sortColumn,
  sortDirection,
  handleSort,

  companiesList = [],
}) => {
  const renderSortIcon = (column) => {
    if (sortColumn !== column) return " ↕";
    return sortDirection === "asc" ? " ▲" : " ▼";
  };

  return (
    <div className="overflow-auto w-100 mt3 bg-white br3 shadow-2">
      <table
        className="records-table collapse bg-white"
        style={{ minWidth: "1700px" }}
      >
        <thead className="sticky-header">
          <tr
            className="bg-gold black"
            style={{ position: "sticky", top: 0, zIndex: 10 }}
          >
            {/* Select */}
            <th className="pa3 tc nowrap bb b--black-10 f2 fw5">
              <input
                type="checkbox"
                checked={selectAll}
                onChange={(e) =>
                  handleSelectAll && handleSelectAll(e.target.checked)
                }
              />
            </th>

            <th
              className="pa3 tl nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("id")}
            >
              ID{renderSortIcon("id")}
            </th>

            <th
              className="pa3 tl nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("farmerid")}
            >
              Farmer ID{renderSortIcon("farmerid")}
            </th>

            <th
              className="pa3 tl nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("username")}
            >
              Username{renderSortIcon("username")}
            </th>

            <th
              className="pa3 tl nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("email")}
            >
              Email{renderSortIcon("email")}
            </th>

            <th
              className="pa3 tl nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("phone")}
            >
              Phone{renderSortIcon("phone")}
            </th>

            <th
              className="pa3 tl nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("company")}
            >
              Company{renderSortIcon("company")}
            </th>

            <th
              className="pa3 tc nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("category")}
            >
              Category{renderSortIcon("category")}
            </th>

            <th
              className="pa3 tc nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("status")}
            >
              Status{renderSortIcon("status")}
            </th>

            <th
              className="pa3 tc nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("joined")}
            >
              Joined{renderSortIcon("joined")}
            </th>

            <th
              className="pa3 tc nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("lastactive")}
            >
              Last Active{renderSortIcon("lastactive")}
            </th>

            <th className="pa3 tc nowrap bb b--black-10 f2 fw5">Actions</th>
          </tr>
        </thead>

        <tbody>
          {users?.length > 0 ? (
            users.map((contact) => (
              <React.Fragment key={contact.id}>
                {editContactId === contact.id ? (
                  <EditableRow
                    editFormData={editFormData}
                    handleEditFormChange={handleEditFormChange}
                    handleEditFormSubmit={handleEditFormSubmit}
                    handleCancelClick={handleCancelClick}
                    isLoadingSave={isLoadingSave}
                  companiesList={companiesList}
  // canEditCompany={true}  // false for normal admins/clerks
                  />
                ) : (
                  <ReadOnlyRow
                    contact={contact}
                    handleEditClick={handleEditClick}
                    handleDeleteClick={handleDeleteClick}
                    selectedUsers={selectedUsers}
                    handleSelectUser={handleSelectUser}
                    deletingId={deletingId}
                  />
                )}
              </React.Fragment>
            ))
          ) : (
            <tr>
              <td colSpan="12" className="tc pa5 silver f4">
                No users found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UsersFilteredView;